// extracted by mini-css-extract-plugin
module.exports = {"userStatus":"ProfileStatus_userStatus__2v1s6","title":"ProfileStatus_title__33__B","status":"ProfileStatus_status__1d6ss"};